import { render, staticRenderFns } from "./ServiceFeeQuotation.vue?vue&type=template&id=182f4d9a&"
import script from "./ServiceFeeQuotation.vue?vue&type=script&lang=ts&"
export * from "./ServiceFeeQuotation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports